import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Layout from '../components/layout';
import OhCleoInMedia from '../components/ohCleoInMedia';
import PressHeader from '../components/pressHeader';
import PressAbout from '../components/pressAbout';
import CompanyAssets from '../components/companyAssets';
import style from './press.module.css';
import FeaturedInPress from '../components/featuredInPress';

const Press = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulWebpageSection {
          edges {
            node {
              childContentfulWebpageSectionContentJsonNode {
                overline
                title
                subTitle
                body1
                body2
              }

              contentfulid
              images {
                fluid {
                  ...GatsbyContentfulFluid
                }
              }
            }
          }
        }
      }
    `,
  );

  const sections = data.allContentfulWebpageSection.edges.reduce((all, one) => {
    const newAll = { ...all };
    newAll[one.node.contentfulid] = {
      ...one.node.childContentfulWebpageSectionContentJsonNode,
      images: one.node.images ? one.node.images : undefined,
    };
    return newAll;
  }, {});
 
  return (
    <Layout
      title="Ohcleo Press"
      showBecomeContentCreator={true}
      showTransparentNav={false}
    >
      <PressHeader section={sections.sectionPressHeader} />
      <div className={style.wrapper}>
        <PressAbout section={sections.sectionPressAbout} />
        <FeaturedInPress></FeaturedInPress>
        <OhCleoInMedia />
        <CompanyAssets />
      </div>
    </Layout>
  );
};

export default Press;
